<template>
  <b-tooltip position="is-left" :label="$t('tooltip.tree')">
    <div style="display:inline;margin-right:5px; margin-bottom:5px;">
      <div
        :class="
          this.$store.getters.sondage_results_count !== 0 ? 'isDisabled' : ''
        "
        v-if="!this.$store.getters.showTreeComponent"
        @click="ShowTreeComponent"
      >
        <img
          src="@/assets/img/icons/tree-icon.png"
          :class="
            this.$store.getters.sondage_results_count !== 0
              ? 'icon'
              : 'icon-disabled'
          "
          alt="tree-icon"
        />
      </div>
      <div v-else @click="ShowTreeComponent">
        <img
          src="@/assets/img/icons/arrow-left-icon.png"
          class="icon"
          alt="arrow-left-icon"
        />
      </div>
    </div>
  </b-tooltip>
</template>

<script>
export default {
  name: 'ButtonTreeSections',
  methods: {
    ShowTreeComponent () {
      if (this.$store.getters.sondage_results_count === 0) {
        this.$store.dispatch('saveQuestions')
        this.$store.commit(
          'SHOW_TREE_COMPONENT',
          !this.$store.getters.showTreeComponent
        )
      }
    }
  }
}
</script>
<style scoped>
.icon {
  width: 15px;
  height: 15px;
  margin-left: 15px;
  margin-right: 5px;
  margin-top: 3px;
  cursor: pointer;
}
.icon-disabled {
  width: 18px;
  height: 18px;
  margin-top: 2px;
  margin-left: 5px;
  margin-right: 5px;
  vertical-align: center;
}
.isDisabled {
  pointer-events: none;
  opacity: 0.3;
}
</style>



// WEBPACK FOOTER //
// src/components/question/components/ButtonTreeSections.vue